import apiClient from "./middleware";

export const qualityAuditApi = {
  videoAudit: async (params: {
    videoUrlOrId: string;
    includeVisualTranscript?: boolean;
    channelId?: string;
    pdf?: boolean;
  }): Promise<Blob | { runId: string; videoId: string; auditText: string; thumbnailAnalysis: string; visualTranscript?: string }> => {
    const url = params.pdf
      ? `/quality-audit/video-audit?pdf=1`
      : "/quality-audit/video-audit";
    const response = await apiClient.post(url, {
      videoUrlOrId: params.videoUrlOrId,
      includeVisualTranscript: params.includeVisualTranscript,
      channelId: params.channelId,
    }, { responseType: params.pdf ? "blob" : "json" });
    return response.data;
  },

  bulkAnalyze: async (params: {
    rows: { videoId: string; title?: string; description?: string }[];
    channelId?: string;
  }): Promise<{ runId: string; results: unknown[]; errors: { videoId: string; error: string }[] }> => {
    const { data } = await apiClient.post("/quality-audit/bulk/analyze", params);
    return data;
  },

  listRuns: async (params?: { channelId?: string; limit?: number }): Promise<{ runs: unknown[] }> => {
    const { data } = await apiClient.get("/quality-audit/runs", { params });
    return data;
  },

  getRun: async (runId: string): Promise<unknown> => {
    const { data } = await apiClient.get(`/quality-audit/runs/${runId}`);
    return data;
  },

  getExportUrl: (runId: string): string => {
    const base = process.env.REACT_APP_SERVER_URL || "http://localhost:8080";
    return `${base}/quality-audit/runs/${runId}/export`;
  },

  downloadExport: async (runId: string, filename?: string): Promise<void> => {
    const response = await apiClient.get(`/quality-audit/runs/${runId}/export`, {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || `quality-audit-${runId}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
